import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  socialLink: {
    '& svg path': {
      transition: `fill ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
    },
    '&:hover, &:focus': {
      '& svg path': {
        fill: `rgb(${theme.palette.white})`,
      },
      outline: 0,
    },
  },
}))

export default useStyles
